import { render } from "./App.vue?vue&type=template&id=094cfbff"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rob/Projects/LaneLabs/portfolio/wp-content/themes/thelane/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__